<template>
    <div class="animated fadeIn">
        <LoadingWidget
            v-if="initStatus != 1"
            :status="initStatus"
            @init="init"
        />
        <div v-else>
            <b-card>
                <div
                    class="d-flex justify-content-between align-items-center mb-3"
                >
                    <h5 class="mb-0">
                        <i class="fa fa-fw fa-user mr-2" />Detail Peserta
                    </h5>
                    <div class="d-flex" style="gap: 0.5rem">
                        <b-button
                            v-if="showKelolaButton"
                            variant="primary"
                            size="sm"
                            @click="$bvModal.show('m-kelola-peserta')"
                        >
                            <i class="fa fa-cogs mr-1" /> Kelola Peserta
                        </b-button>
                        <b-button
                            v-if="submission.blacklist"
                            variant="warning"
                            size="sm"
                            :disabled="isBlacklisting"
                            @click="unblacklist"
                        >
                            <i class="fa fa-undo mr-1" /> Batal Skorsing
                        </b-button>
                        <b-button
                            v-else-if="canBlacklist"
                            variant="danger"
                            size="sm"
                            :disabled="isBlacklisting"
                            @click="$bvModal.show('m-blacklist')"
                        >
                            <i class="fa fa-ban mr-1" /> Skorsing
                        </b-button>
                    </div>
                </div>
                <hr />

                <b-alert :show="!!submission.blacklist" variant="warning" class="py-2 small">
                    <i class="fa fa-ban mr-1" />
                    Customer terkena skorsing sampai
                    <strong>{{ submission.blacklist && $helper.parseDate(submission.blacklist.blacklisted_until) }}</strong>
                    ({{ submission.blacklist && submission.blacklist.reason_label }})<span
                        v-if="submission.blacklist && submission.blacklist.created_by"
                    >, oleh {{ submission.blacklist.created_by }}</span>.
                </b-alert>

                <b-row>
                    <!-- Left: Customer info -->
                    <b-col md="6">
                        <h6 class="font-weight-bold text-primary mb-3">
                            Informasi Peserta
                        </h6>
                        <table class="table table-borderless table-sm">
                            <tr>
                                <td style="width: 35%">
                                    <strong>Nama</strong>
                                </td>
                                <td>
                                    :
                                    {{
                                        submission.customer
                                            ? submission.customer.name
                                            : "-"
                                    }}
                                </td>
                            </tr>
                            <tr>
                                <td><strong>No. Telepon</strong></td>
                                <td>
                                    :
                                    {{
                                        submission.customer
                                            ? submission.customer.phone
                                            : "-"
                                    }}
                                </td>
                            </tr>
                            <tr>
                                <td><strong>PAX</strong></td>
                                <td>: {{ submission.pax }}</td>
                            </tr>
                            <tr>
                                <td><strong>Slot</strong></td>
                                <td>: {{ submission.slot }}</td>
                            </tr>
                            <tr>
                                <td><strong>Tanggal Submit</strong></td>
                                <td>
                                    :
                                    <span v-if="submission.registered_at">
                                        {{
                                            $helper.parseDate(
                                                submission.registered_at
                                            )
                                        }},
                                        {{
                                            $helper.parseHourMinute(
                                                submission.registered_at
                                            )
                                        }}
                                    </span>
                                    <span v-else>-</span>
                                </td>
                            </tr>
                            <tr>
                                <td><strong>Status Pendaftaran</strong></td>
                                <td>
                                    :
                                    <b-badge
                                        :variant="
                                            getSubmissionStatusBadge(
                                                submission.status
                                            )[0]
                                        "
                                    >
                                        {{
                                            getSubmissionStatusBadge(
                                                submission.status
                                            )[1]
                                        }}
                                    </b-badge>
                                </td>
                            </tr>
                        </table>
                    </b-col>

                    <!-- Right: Concert / Event status info -->
                    <b-col md="6">
                        <h6 class="font-weight-bold text-primary mb-3">
                            Status Acara & Pembayaran
                        </h6>
                        <table class="table table-borderless table-sm">
                            <tr>
                                <td style="width: 35%">
                                    <strong>Nama Konser</strong>
                                </td>
                                <td>
                                    :
                                    {{
                                        submission.concert
                                            ? submission.concert.name
                                            : "-"
                                    }}
                                </td>
                            </tr>
                            <tr>
                                <td><strong>Tanggal Konser</strong></td>
                                <td>
                                    :
                                    {{
                                        submission.concert
                                            ? $helper.parseDate(
                                                  submission.concert.date
                                              )
                                            : "-"
                                    }}
                                </td>
                            </tr>
                            <tr>
                                <td><strong>Status Pembayaran DP</strong></td>
                                <td>
                                    :
                                    <b-badge
                                        :variant="
                                            getPaymentStatusBadgeForConcert(
                                                submission.payment_status,
                                                submission.concert && submission.concert.require_down_payment
                                            )[0]
                                        "
                                    >
                                        {{
                                            getPaymentStatusBadgeForConcert(
                                                submission.payment_status,
                                                submission.concert && submission.concert.require_down_payment
                                            )[1]
                                        }}
                                    </b-badge>
                                </td>
                            </tr>
                            <tr
                                v-for="(slot, i) in (submission.slots || [])"
                                :key="slot.id"
                            >
                                <td><strong>Slot {{ i + 1 }}</strong></td>
                                <td>
                                    :
                                    <b-badge
                                        :variant="
                                            getAttendanceStatusBadge(
                                                slot.attendance_status
                                            )[0]
                                        "
                                    >
                                        {{
                                            getAttendanceStatusBadge(
                                                slot.attendance_status
                                            )[1]
                                        }}
                                    </b-badge>
                                    <b-badge
                                        class="ml-1"
                                        :variant="
                                            getAchievementStatusBadge(
                                                slot.achievement_status
                                            )[0]
                                        "
                                    >
                                        {{
                                            getAchievementStatusBadge(
                                                slot.achievement_status
                                            )[1]
                                        }}
                                    </b-badge>
                                </td>
                            </tr>
                        </table>
                    </b-col>
                </b-row>

                <div v-if="submission.refund">
                    <b-card class="border-0 shadow-sm mb-4">
                        <h6 class="font-weight-bold text-primary mb-3">
                            <i class="fa fa-info-circle mr-1" /> Detail Refund
                            (Skorsing)
                        </h6>
                        <b-row>
                            <b-col md="6">
                                <table
                                    class="table table-borderless table-sm mb-0"
                                >
                                    <tr>
                                        <td style="width: 35%">
                                            <strong>Status</strong>
                                        </td>
                                        <td>
                                            :
                                            <b-badge
                                                :variant="
                                                    getRefundStatusBadge(
                                                        submission.refund.status
                                                    )[0]
                                                "
                                                class="text-uppercase"
                                            >
                                                {{
                                                    getRefundStatusBadge(
                                                        submission.refund.status
                                                    )[1]
                                                }}
                                            </b-badge>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td><strong>Nominal</strong></td>
                                        <td>
                                            :
                                            <span
                                                class="text-danger font-weight-bold"
                                            >
                                                Rp.
                                                {{
                                                    $helper.formatThousand(
                                                        submission.refund.amount
                                                    )
                                                }}
                                            </span>
                                        </td>
                                    </tr>
                                    <tr v-if="submission.refund.notes">
                                        <td><strong>Catatan</strong></td>
                                        <td>: {{ submission.refund.notes }}</td>
                                    </tr>
                                </table>
                            </b-col>
                            <b-col md="6">
                                <table
                                    class="table table-borderless table-sm mb-0"
                                >
                                    <tr v-if="submission.refund.confirmed_by">
                                        <td style="width: 35%">
                                            <strong>Dikonfirmasi Oleh</strong>
                                        </td>
                                        <td>
                                            :
                                            {{ submission.refund.confirmed_by }}
                                            <span
                                                v-if="
                                                    submission.refund
                                                        .confirmed_at
                                                "
                                                class="text-muted small d-block mt-1"
                                            >
                                                Pada:
                                                {{
                                                    $helper.parseDate(
                                                        submission.refund
                                                            .confirmed_at
                                                    )
                                                }}
                                                pukul
                                                {{
                                                    $helper.parseHourMinute(
                                                        submission.refund
                                                            .confirmed_at
                                                    )
                                                }}
                                            </span>
                                        </td>
                                    </tr>
                                    <tr v-if="submission.refund.proof_url">
                                        <td><strong>Bukti Transfer</strong></td>
                                        <td>
                                            :
                                            <a
                                                :href="
                                                    submission.refund.proof_url
                                                "
                                                target="_blank"
                                            >
                                                <i
                                                    class="fa fa-fw fa-image mr-1"
                                                />Lihat Bukti
                                            </a>
                                        </td>
                                    </tr>
                                </table>
                            </b-col>
                        </b-row>
                    </b-card>
                </div>

                <div class="mt-2">
                    <h6 class="font-weight-bold mb-3">
                        Daftar Transaksi Down Payment
                    </h6>
                    <b-table
                        bordered
                        hover
                        show-empty
                        responsive
                        :items="submission.down_payment_transactions || []"
                        :fields="transactionFields"
                    >
                        <template v-slot:empty>
                            Tidak ada transaksi down payment.
                        </template>
                        <template v-slot:cell(amount)="row">
                            Rp. {{ $helper.formatThousand(row.item.amount) }}
                        </template>
                        <template v-slot:cell(status)="row">
                            <b-badge
                                :variant="getTxnStatusBadge(row.item.status)[0]"
                            >
                                {{ getTxnStatusBadge(row.item.status)[1] }}
                            </b-badge>
                        </template>
                        <template v-slot:cell(created_at)="row">
                            <span v-if="row.item.created_at">
                                {{ $helper.parseDate(row.item.created_at) }},
                                {{
                                    $helper.parseHourMinute(row.item.created_at)
                                }}
                            </span>
                            <span v-else>-</span>
                        </template>
                        <template v-slot:cell(paid_at)="row">
                            <span v-if="row.item.paid_at">
                                {{ $helper.parseDate(row.item.paid_at) }},
                                {{ $helper.parseHourMinute(row.item.paid_at) }}
                            </span>
                            <span v-else>-</span>
                        </template>
                    </b-table>
                </div>
            </b-card>
        </div>

        <ModalKelolaPeserta
            :submission="submission"
            :require-down-payment="submission.concert && submission.concert.require_down_payment !== false"
            @refresh="getDetail"
        />

        <b-modal
            id="m-blacklist"
            title="Skorsing Customer"
            centered
            ok-variant="danger"
            ok-title="Skorsing"
            cancel-title="Batal"
            :ok-disabled="isBlacklisting"
            @show="blacklistReason = null"
            @ok="submitBlacklist"
        >
            <p class="mb-3">
                Apakah Anda yakin ingin memberi skorsing ke customer ini selama
                30 hari? Registrasi konser lain miliknya akan ikut dibatalkan dan
                DP-nya diproses refund.
            </p>
            <b-form-group label="Alasan" class="mb-0">
                <div class="d-flex">
                    <b-button
                        class="mr-2 flex-fill"
                        :variant="blacklistReason === 2 ? 'danger' : 'outline-danger'"
                        @click="blacklistReason = 2"
                    >
                        <i class="fa fa-times mr-1" /> Tidak Hadir
                    </b-button>
                    <b-button
                        class="flex-fill"
                        :variant="blacklistReason === 3 ? 'danger' : 'outline-danger'"
                        @click="blacklistReason = 3"
                    >
                        <i class="fa fa-ban mr-1" /> Tidak Capai Target
                    </b-button>
                </div>
            </b-form-group>
        </b-modal>
    </div>
</template>

<script>
import {
    SUBMISSION_STATUS,
    PAYMENT_STATUS,
    ATTENDANCE_STATUS,
    ACHIEVEMENT_STATUS,
    TXN_STATUS,
    REFUND_STATUS,
    getSubmissionStatusBadge,
    getPaymentStatusBadge,
    getPaymentStatusBadgeForConcert,
    getAttendanceStatusBadge,
    getAchievementStatusBadge,
    getTxnStatusBadge,
    getRefundStatusBadge
} from "../konserHelper";
import ModalKelolaPeserta from "./ModalKelolaPeserta.vue";

export default {
    components: {
        ModalKelolaPeserta
    },
    data() {
        return {
            SUBMISSION_STATUS,
            PAYMENT_STATUS,
            ATTENDANCE_STATUS,
            ACHIEVEMENT_STATUS,
            TXN_STATUS,
            REFUND_STATUS,

            initStatus: 0,
            isBlacklisting: false,
            blacklistReason: null,
            submission: {},
            transactionFields: [
                { key: "invoice_number", label: "No. Invoice" },
                { key: "amount", label: "Nominal" },
                {
                    key: "status",
                    label: "Status",
                    thClass: "text-center",
                    tdClass: "text-center"
                },
                { key: "created_at", label: "Tanggal Dibuat" },
                { key: "paid_at", label: "Tanggal Bayar" }
            ]
        };
    },
    computed: {
        showKelolaButton() {
            if (!this.submission || this.submission.status === undefined) {
                return false;
            }

            if (
                this.submission.status === this.SUBMISSION_STATUS.EXPIRED ||
                this.submission.status === this.SUBMISSION_STATUS.CANCELED ||
                this.submission.status === this.SUBMISSION_STATUS.WAITLISTED ||
                this.submission.status === this.SUBMISSION_STATUS.FULL ||
                this.submission.payment_status === this.PAYMENT_STATUS.EXPIRED
            ) {
                return false;
            }

            return (this.submission.slots || []).some(
                slot =>
                    slot.attendance_status === null ||
                    (slot.attendance_status === this.ATTENDANCE_STATUS.PRESENT &&
                        slot.achievement_status === null)
            );
        },

        canBlacklist() {
            const s = this.submission;
            if (!s || s.status === undefined) return false;
            if (s.is_blacklisted) return false;
            return ![
                this.SUBMISSION_STATUS.EXPIRED,
                this.SUBMISSION_STATUS.CANCELED,
                this.SUBMISSION_STATUS.WAITLISTED,
                this.SUBMISSION_STATUS.FULL
            ].includes(s.status);
        }
    },

    methods: {
        getSubmissionStatusBadge,
        getPaymentStatusBadge,
        getPaymentStatusBadgeForConcert,
        getAttendanceStatusBadge,
        getAchievementStatusBadge,
        getTxnStatusBadge,
        getRefundStatusBadge,

        init() {
            this.initStatus = 0;
            this.getDetail()
                .then(() => {
                    this.initStatus = 1;
                })
                .catch(() => {
                    this.initStatus = -1;
                });
        },

        getDetail() {
            return this.$axios
                .get(`concerts/submissions/${this.$route.params.id}`)
                .then(res => {
                    this.submission = res.data.data;
                })
                .catch(error => {
                    this.$helper.parseError(this, error);
                    throw error;
                });
        },

        submitBlacklist(bvModalEvt) {
            bvModalEvt.preventDefault();

            if (!this.blacklistReason) {
                this.$helper.toastError(this, "Pilih alasan skorsing terlebih dahulu.");
                return;
            }

            this.isBlacklisting = true;
            this.$axios
                .post(`concerts/submissions/${this.submission.id}/blacklist`, {
                    reason: this.blacklistReason
                })
                .then(res => {
                    this.submission = res.data.data;
                    this.$bvModal.hide("m-blacklist");
                    this.$helper.toastSuccess(this, "Customer berhasil diskorsing.");
                })
                .catch(error => this.$helper.parseError(this, error))
                .finally(() => (this.isBlacklisting = false));
        },

        unblacklist() {
            this.$bvModal
                .msgBoxConfirm(
                    "Apakah Anda yakin ingin membatalkan skorsing ini? Registrasi yang tadi dibatalkan akan diaktifkan kembali.",
                    {
                        title: "Batal Skorsing",
                        okVariant: "warning",
                        okTitle: "Batal Skorsing",
                        cancelTitle: "Tutup",
                        centered: true
                    }
                )
                .then(ok => {
                    if (!ok) return;

                    this.isBlacklisting = true;
                    this.$axios
                        .delete(`concerts/submissions/${this.submission.id}/blacklist`)
                        .then(res => {
                            this.submission = res.data.data;
                            this.$helper.toastSuccess(this, "Skorsing dibatalkan.");
                        })
                        .catch(error => this.$helper.parseError(this, error))
                        .finally(() => (this.isBlacklisting = false));
                });
        }
    },

    created() {
        this.init();
    }
};
</script>
